import { saveDate } from './campana.actions'

export const saveDates = (ini, end) => dispatch =>{
    dispatch(saveDate(ini, end))
}